module.exports = __webpack_public_path__ + "img/icon-play.2c7af59e.svg";